import React from "react";
import { YoutubeVideo } from "@/components";
import { VideoData } from "@/hooks/useHomePageData";

interface VideoSectionProps {
  video: VideoData;
}

const VideoSection: React.FC<VideoSectionProps> = ({ video }) => {
  return (
    <section className="flex flex-col gap-6 mt-12 md:mt-14" aria-labelledby="video-title">
      <div className="max-w-3xl mx-auto w-full">
        <YoutubeVideo
          videoUrl={video.url}
          title={video.title}
          className="mb-4"
        />
      </div>
    </section>
  );
};

export default VideoSection;
